var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('location-header'),_c('order-coupon-display'),_c('order-menu-header'),_c('order-menu-menus'),_c('order-menu-footer'),_c('order-order-drawer'),_c('order-coupon-drawer'),_c('order-features-drawer'),_c('order-myway-drawer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }